export default __webpack_public_path__ + "static/media/discord.d452f730.svg";